import {
  ExclamationMarkCircleFilled,
  ExclamationMarkTriangleFilled,
} from "components/icons/generated";
import IconWithTooltip from "components/IconWithTooltip";
import { IconProps } from "ds/components/Icon";

import { WorkerUsageMetricCardSeverity } from "./types";

type SeverityConfig = {
  icon: IconProps["src"];
  color: IconProps["color"];
};

const SEVERITY_CONFIG: Record<WorkerUsageMetricCardSeverity, SeverityConfig> = {
  warning: { icon: ExclamationMarkTriangleFilled, color: "warning" },
  danger: { icon: ExclamationMarkCircleFilled, color: "danger" },
};

type UsageWorkersNewSeverityIconProps = {
  severity: WorkerUsageMetricCardSeverity;
  tooltip: string;
};

const UsageWorkersNewSeverityIcon = ({ severity, tooltip }: UsageWorkersNewSeverityIconProps) => {
  const { icon, color } = SEVERITY_CONFIG[severity];

  return (
    <IconWithTooltip
      icon={icon}
      tooltip={tooltip}
      tooltipWidthMode="maxWidthSm"
      color={color}
      noShrink
    />
  );
};

export default UsageWorkersNewSeverityIcon;
